"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.broadcastTransaction = exports.getTransactionParams = exports.getAccount = void 0;
var bignumber_js_1 = require("bignumber.js");
var env_1 = require("../../../env");
var network_1 = __importDefault(require("../../../network"));
var BASE_URL = (0, env_1.getEnv)("API_ALGORAND_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
var NODE_URL = "".concat(BASE_URL, "/ps2/v2");
var fullUrl = function (route) { return "".concat(NODE_URL).concat(route); };
var getAccount = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var data, assets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: fullUrl("/accounts/".concat(address))
                })];
            case 1:
                data = (_a.sent()).data;
                assets = data.assets
                    ? data.assets.map(function (a) {
                        return {
                            assetId: a["asset-id"].toString(),
                            balance: new bignumber_js_1.BigNumber(a.amount)
                        };
                    })
                    : [];
                return [2 /*return*/, {
                        round: data.round,
                        address: data.address,
                        balance: new bignumber_js_1.BigNumber(data.amount),
                        pendingRewards: new bignumber_js_1.BigNumber(data["pending-rewards"]),
                        assets: assets
                    }];
        }
    });
}); };
exports.getAccount = getAccount;
var getTransactionParams = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "GET",
                    url: fullUrl("/transactions/params")
                })];
            case 1:
                data = (_b.sent()).data;
                return [2 /*return*/, {
                        fee: data["fee"],
                        minFee: data["min-fee"],
                        firstRound: (_a = data["first-round"]) !== null && _a !== void 0 ? _a : 0,
                        lastRound: data["last-round"],
                        genesisID: data["genesis-id"],
                        genesisHash: data["genesis-hash"]
                    }];
        }
    });
}); };
exports.getTransactionParams = getTransactionParams;
var broadcastTransaction = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: fullUrl("/transactions"),
                    data: payload,
                    headers: { "Content-Type": "application/x-binary" }
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data.txId];
        }
    });
}); };
exports.broadcastTransaction = broadcastTransaction;
//# sourceMappingURL=algodv2.js.map